import React, { Component } from "react";
import Layout from "./../layouts/Index";
import { withRouter } from "react-router-dom";
import { Formik } from "formik";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { Row, Col, Container, Form, Button, Card, InputGroup } from "react-bootstrap";
import { addMoq, fetchPricing, fetchShippingFees } from "./../../store/actions/MoqActions";
import { getAllProducts } from "./../../store/actions/ProductActions";
import { createSchema } from "./../../helpers/validation/moq";
import { FiPlus, FiTrash2 } from "react-icons/fi";
import Select from "react-select";
import CurrencyCodes from "currency-codes/data";
import BlockLoader from "./../contentloaders/BlockLoader";
import { debounce } from 'lodash';

class Create extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,

      fetching: false,

      products: [],

      varying_sizes: 0,

      dynamic_target_moq: 0,

      dynamic_moq_per_person: 0,

      moq_attributes: [
        {
          size_id: 0,
          supplier_price: "",
          price: "",
          shipping_fee_air: "",
          shipping_fee_sea: "",
          weight: "",
          below_moq_price: "",
          length: "",
          width: "",
          height: "",
        },
      ],

      sizes: [],
    };
    this.debouncedFetchPricing = debounce(this.fetchPricing, 500);
    this.debouncedFetchShippingFees = debounce(this.fetchShippingFees, 500);
  }

  componentDidMount = async () => {
    this.fetchProducts();
  };

  componentWillUnmount = async () => {
    // Cancel any pending debounced calls
    if (this.debouncedFetchPricing && this.debouncedFetchPricing.cancel) {
      this.debouncedFetchPricing.cancel();
    }

    if (this.debouncedFetchShippingFees && this.debouncedFetchShippingFees.cancel) {
      this.debouncedFetchShippingFees.cancel();
    }

  };

  fetchProducts = async () => {
    try {
      this.setState({ fetching: true });
      const results = await this.props.getAllProducts(true);
      if (results?.products) {
        let data = [];
        for (let i = 0; i < results.products.length; i++) {
          data.push({
            value: results.products[i].id,
            label: results.products[i].name,
            varying_sizes: results.products[i].varying_sizes,
            sizes: results.products[i].readable_sizes,
            images: results.products[i].images,
          });
        }
        this.setState({ products: data });
      }
      this.setState({ fetching: false });
    } catch (error) {
      console.log(error);
      this.setState({ fetching: false });
    }
  };

  create = async (data) => {
    try {
      let values = data;
      if (values.product_id === null || values.product_id === undefined) {
        return toast.error("Product is required !", {
          position: "bottom-center",
        });
      }

      if (values.weight === "" && this.state.varying_sizes === 0) {
        return toast.error("Weight is required!", {
          position: "bottom-center",
        });
      }

      if (values.length === "" && this.state.varying_sizes === 0) {
        return toast.error("Length is required!", {
          position: "bottom-center",
        });
      }

      if (values.width === "" && this.state.varying_sizes === 0) {
        return toast.error("Width is required!", {
          position: "bottom-center",
        });
      }

      if (values.height === "" && this.state.varying_sizes === 0) {
        return toast.error("Height is required!", {
          position: "bottom-center",
        });
      }

      if (values.below_moq_price === "" && this.state.varying_sizes === 0) {
        return toast.error("Below MOQ Price is required !", {
          position: "bottom-center",
        });
      }
      if (this.state.varying_sizes === 1) {
        let attributes = this.state.moq_attributes;

        let hasSupplierPrice = attributes.every(
          (attr) => attr?.supplier_price !== "" && attr?.supplier_price !== 0
        );
        if (!hasSupplierPrice) {
          return toast.error(
            "Supplier price(s) in MOQ attributes is required and should not have zero values !",
            {
              position: "bottom-center",
            }
          );
        }

        let hasPrice = attributes.every(
          (attr) => attr?.price !== "" && attr?.price !== 0
        );
        if (!hasPrice) {
          return toast.error(
            "Price(s) in MOQ attributes is required and should not have zero values !",
            {
              position: "bottom-center",
            }
          );
        }

        let hasBelowMOQPrice = attributes.every(
          (attr) => attr?.below_moq_price !== "" && attr?.below_moq_price !== 0
        );
        if (!hasBelowMOQPrice) {
          return toast.error(
            "Below MOQ Price(s) in MOQ attributes is required and should not have zero values !",
            {
              position: "bottom-center",
            }
          );
        }

        let hasWeight = attributes.every((attr) => attr?.weight !== "");
        if (!hasWeight) {
          return toast.error("Weight(s) in MOQ attributes is required !", {
            position: "bottom-center",
          });
        }

        let hasLength = attributes.every((attr) => attr?.length !== "");
        if (!hasLength) {
          return toast.error("Length(s) in MOQ attributes is required !", {
            position: "bottom-center",
          });
        }

        let hasWidth = attributes.every((attr) => attr?.width !== "");
        if (!hasWidth) {
          return toast.error("Width(s) in MOQ attributes is required !", {
            position: "bottom-center",
          });
        }

        let hasHeight = attributes.every((attr) => attr?.height !== "");
        if (!hasHeight) {
          return toast.error("Height(s) in MOQ attributes is required !", {
            position: "bottom-center",
          });
        }

        let hasSize = attributes.every(
          (attr) => attr?.size_id !== "" && attr?.size_id !== 0
        );
        if (!hasSize) {
          return toast.error(
            "Please select appropriate size(s) in MOQ attributes !",
            {
              position: "bottom-center",
            }
          );
        }

        values.moq_attributes = this.state.moq_attributes;
      } else {
        if (values.supplier_price === "" || values.supplier_price === 0) {
          return toast.error(
            "Supplier Price is required and should not have zero value !",
            {
              position: "bottom-center",
            }
          );
        }

        if (values.price === "" || values.price === 0) {
          return toast.error(
            "Price is required and must not have zero value !",
            {
              position: "bottom-center",
            }
          );
        }

        if (values.weight === "") {
          return toast.error("Weight is required !", {
            position: "bottom-center",
          });
        }

        if (values.length === "") {
          return toast.error("Lenght is required !", {
            position: "bottom-center",
          });
        }

        if (values.width === "") {
          return toast.error("Width is required !", {
            position: "bottom-center",
          });
        }

        if (values.height === "") {
          return toast.error("Height is required !", {
            position: "bottom-center",
          });
        }

        if (values.below_moq_price === "") {
          return toast.error("Below MOQ Price is required !", {
            position: "bottom-center",
          });
        }

        values.moq_attributes = [
          {
            shipping_fee_air: values.shipping_fee_air,
            shipping_fee_sea: values.shipping_fee_sea,
            weight: values.weight,
            length: values.length,
            width: values.width,
            height: values.height,
          },
        ];

        if (values.shipping_fee_air) delete values.shipping_fee_air;

        if (values.shipping_fee_sea) delete values.shipping_fee_sea;

        if (values.weight) delete values.weight;

        if (values.length) delete values.length;

        if (values.width) delete values.width;

        if (values.height) delete values.height;
      }

      this.setState({ loading: true });

      const result = await this.props.addMoq({
        ...values,
        product_id: values?.product_id?.value || null,
      });

      if (result) {
        this.setState({ loading: false });

        toast.success("MOQ Added Successfully !", {
          position: "bottom-center",
        });

        return this.props.history.push(`/admin/moqs`);
      }
    } catch (error) {
      this.setState({ loading: false });
      console.log(error);
      if (error?.response?.data?.message) {
        toast.error(`${error?.response?.data?.message}`, {
          position: "bottom-center",
        });
      }
    }
  };

  fetchPricing = async (price, currency, dynamicPricing, setFieldValueOrIndex, dynamicSetFieldValue) => {
    try {
      const payload = {
        source_cost: price,
        source_currency: currency,
      };
      const result = await this.props.fetchPricing(payload);
      if (result && result.status === "success" && result.data) {
        if (dynamicPricing === 0) {
          setFieldValueOrIndex('price', result.data.price_per_piece);
          setFieldValueOrIndex('quantity', result.data.target_moq);
          setFieldValueOrIndex('min_quantity', result.data.moq_per_person);
          setFieldValueOrIndex('below_moq_price', result.data.below_moq_price_per_piece);
        } else {
          // Dynamic array - update state
          const index = setFieldValueOrIndex;
          const list = [...this.state.moq_attributes];

          // Update dynamic array values
          list[index].price = result.data.price_per_piece;
          list[index].below_moq_price = result.data.below_moq_price_per_piece;

          // Compute dynamic quantities
          const moq_attributes_size = list.length;
          const dynamic_target_moq = (this.state.dynamic_target_moq + result.data.target_moq) / moq_attributes_size;
          const dynamic_moq_per_person = (this.state.dynamic_moq_per_person + Math.max(1, result.data.moq_per_person) / moq_attributes_size);

          // Update state first
          this.setState(
            {
              moq_attributes: list,
              dynamic_target_moq,
              dynamic_moq_per_person,
            },
            () => {
              if (dynamicSetFieldValue) {
                dynamicSetFieldValue('quantity', dynamic_target_moq);
                dynamicSetFieldValue('min_quantity', dynamic_moq_per_person);
              }
            }
          );

        }
      }
    } catch (err) {
      console.error("Pricing API error:", err);
    }
  };

  fetchShippingFees = async (shippingType, weight, length, width, height, dynamicPricing, setFieldValueOrIndex) => {
    try {
      const payload = {
        type: shippingType,
      };
      if (shippingType === "air") {
        payload.weight = weight;
      } else if (shippingType === "sea") {
        payload.length = length;
        payload.width = width;
        payload.height = height;
      }
      const result = await this.props.fetchShippingFees(payload);
      if (result && result.status === "success") {
        if (dynamicPricing === 0) {
          if (shippingType === "air"){
            setFieldValueOrIndex('shipping_fee_air', result.shipping_fee);
          } else if (shippingType === "sea"){
            setFieldValueOrIndex('shipping_fee_sea', result.shipping_fee);
          }
        } else {
          const index = setFieldValueOrIndex;
          const attributes = [...this.state.moq_attributes];
          if (shippingType === "air"){
            attributes[index].shipping_fee_air = result.shipping_fee;
          } else if (shippingType === "sea"){
            attributes[index].shipping_fee_sea = result.shipping_fee;
          }
          this.setState({ moq_attributes: attributes });
        }
      }
    } catch (err) {
      console.error("Shipping Fees API error:", err);
    }
  };

  handleSupplierSinglePriceChange = (e, handleChange, values, dynamicPricing, setFieldValue) => {
    handleChange(e);
    
    const supplierPrice = e.target.value;
    const supplierCurrency = values.supplier_currency;
    
    if (supplierPrice && supplierCurrency && supplierPrice > 0) {
      this.debouncedFetchPricing(supplierPrice, supplierCurrency, dynamicPricing, setFieldValue);
    }
  };

  handleSingleAirShippingChange = (e, handleChange, dynamicPricing, setFieldValue) => {
    handleChange(e);
    
    const weight = e.target.value;
    
    if (weight &&  weight > 0) {
      this.debouncedFetchShippingFees("air", weight, null, null, null, dynamicPricing, setFieldValue);
    }
  };

  handleSingleSeaShippingChange = (e, handleChange, dynamicPricing, setFieldValue, values) => {
    handleChange(e);
    
    const { name, value } = e.target;

    // Update the corresponding field in values (Formik's values may not reflect immediately)
    const updatedValues = {
      ...values,
      [name]: value,
    };

    const { length, width, height } = updatedValues;

    // Check if all three fields are filled with valid numbers
    if (length && width && height) {
      this.debouncedFetchShippingFees("sea", null, length, width, height, dynamicPricing, setFieldValue);
    }
  };

  handleInputChange = async (e, index, values, dynamicSetFieldValue = null) => {
    const { moq_attributes } = this.state;

    const { name, value } = e.target;

    let attributes = [...moq_attributes];

    attributes[index][name] = parseInt(value);

    const { length, width, height } = attributes[index];

    this.setState({ moq_attributes: attributes });
    // If supplier_price changed, fetch pricing
    if (name === "supplier_price" && value) {
      const currency = values.supplier_currency;
      if (currency && value > 0) {
        const result = await this.debouncedFetchPricing(value, currency, 1, index, dynamicSetFieldValue);
        if (result) {
          attributes[index].price = result.price_per_piece;
          attributes[index].below_moq_price = result.below_moq_price_per_piece;
          this.setState({ moq_attributes: attributes });
        }
      }
    }

    // If weight changed, fetch air shipping fees
    if (name === "weight" && value > 0) {
      const result = await this.debouncedFetchShippingFees("air", value, null, null, null, 1, index);
      if (result) {
        attributes[index].shipping_fee_air = result.shipping_fee;
        this.setState({ moq_attributes: attributes });
      }
    }
    // If length, width and height changed, fetch sea shipping fees
    if (Number(length) > 0 && Number(width) > 0 && Number(height) > 0) {
      const result = await this.debouncedFetchShippingFees(
        "sea",
        null,
        length,
        width,
        height,
        1,
        index
      );

      if (result) {
        attributes[index].shipping_fee_sea = result.shipping_fee;
        this.setState({ moq_attributes: attributes });
      }
    }
  };

  handleRemoveClick = (index) => {
    const { moq_attributes } = this.state;

    let list = [...moq_attributes];

    list.splice(index, 1);

    this.setState({ moq_attributes: list });
  };

  handleAddClick = () => {
    let { moq_attributes } = this.state;
    this.setState({
      moq_attributes: [
        ...moq_attributes,
        {
          size_id: 0,
          supplier_price: "",
          price: "",
          shipping_fee_air: "",
          shipping_fee_sea: "",
          weight: "",
          lenght: "",
          width: "",
          height: "",
          below_moq_price: "",
        },
      ],
    });
  };

  render() {
    const { loading, varying_sizes, moq_attributes, fetching } = this.state;
    return (
      <Layout>
        <Container>
          <Row>
            {!loading && (
              <Col sm="12">
                <h4>Create New Campaign</h4>
              </Col>
            )}
            <Col sm="12" style={{ minHeight: "80vh", padding: "1.5em 0" }}>
              {fetching ? (
                <BlockLoader
                  width="100%"
                  height="400px"
                  innerWidth="100%"
                  innerHeight="100%"
                />
              ) : (
                <Row>
                  {
                    <Col sm="12">
                      <Card>
                        <Card.Body>
                          <Formik
                            initialValues={{
                              product_id: null,
                              quantity: "",
                              min_quantity: "",
                              supplier_price: "",
                              price: 0,
                              start_date: "",
                              end_date: "",
                              shipping_fee_air: "",
                              shipping_fee_sea: "",
                              supplier_currency: "",
                              source: "",
                              below_moq_price: "",
                              weight: "",
                              length: "",
                              width: "",
                              height: "",
                            }}
                            validationSchema={createSchema}
                            onSubmit={async (
                              values,
                              { setSubmitting, resetForm }
                            ) => {
                              if (varying_sizes === 1) {
                                delete values.supplier_price;

                                delete values.price;

                                delete values.shipping_fee_air;

                                delete values.shipping_fee_sea;

                                delete values.weight;

                                delete values.length;

                                delete values.width;

                                delete values.height;

                                delete values.below_moq_price;
                              }

                              this.create(values);
                            }}
                          >
                            {({
                              values,
                              errors,
                              touched,
                              handleChange,
                              handleBlur,
                              handleSubmit,
                              isSubmitting,
                              setFieldTouched,
                              setFieldValue,
                            }) => (
                              <Form
                                noValidate
                                onSubmit={(e) => {
                                  e.preventDefault();
                                  handleSubmit();
                                }}
                              >
                                <Row>
                                  <Col sm="6">
                                    <Form.Group
                                      style={{ marginTop: "1em" }}
                                      controlId="product_id"
                                    >
                                      <Form.Label>Product</Form.Label>
                                      <Select
                                        defaultValue={values.product_id}
                                        value={values.product_id}
                                        options={this.state.products}
                                        onChange={(value) => {
                                          this.setState({
                                            varying_sizes: value.varying_sizes,
                                            sizes: value.sizes,
                                            selectedProduct: value, // store selected product
                                          });
                                          setFieldValue("product_id", value);
                                        }}
                                        onBlur={() => {
                                          setFieldTouched("product_id", true);
                                        }}
                                        touched={touched.product_id}
                                      />

                                      {(errors.product_id ||
                                        touched.product_id) && (
                                        <Form.Control.Feedback type="invalid">
                                          {errors.product_id}
                                        </Form.Control.Feedback>
                                      )}
                                    </Form.Group>
                                    {this.state.selectedProduct &&
                                      this.state.selectedProduct.images &&
                                      this.state.selectedProduct.images.length > 0 && (
                                      <div style={{ marginTop: "1em" }}>
                                        <Form.Label>Product Images</Form.Label>
                                        <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                                        {this.state.selectedProduct.images.slice(0, 3).map((img, idx) => (
                                        <img
                                        key={idx}
                                        src={img}
                                        alt="Product"
                                        style={{
                                          width: "80px",
                                          height: "80px",
                                          objectFit: "cover",
                                          borderRadius: "6px",
                                          border: "1px solid #eee",
                                        }}
                                        />
                                        ))}
                                      </div>
                                    </div>
                                      )}
                                  </Col>
                                  <Col sm="6">
                                    <Form.Group
                                      style={{ marginTop: "1em" }}
                                      controlId="source"
                                    >
                                      <Form.Label>Source</Form.Label>

                                      <Form.Control
                                        type="text"
                                        placeholder="Source"
                                        name="source"
                                        isValid={
                                          touched.source && !errors.source
                                        }
                                        isInvalid={
                                          errors.source && touched.source
                                        }
                                        value={values.source}
                                        onChange={handleChange}
                                      />

                                      {errors.source && touched.source && (
                                        <Form.Control.Feedback type="invalid">
                                          {errors.source}
                                        </Form.Control.Feedback>
                                      )}
                                    </Form.Group>
                                  </Col>
                                </Row>

                                <Card style={{ marginTop: "1.5em" }}>
                                  <Card.Header as="h6">Pricing and Quantities</Card.Header>
                                  <Card.Body>
                                    <Row>
                                      <Col sm={varying_sizes === 0 ? "6" : "12"}>
                                        <Form.Group
                                          style={{ marginTop: "1em" }}
                                          controlId="supplier_currency"
                                        >
                                          <Form.Label>Supplier Currency</Form.Label>

                                          <Form.Control
                                            as="select"
                                            isValid={
                                              touched.supplier_currency &&
                                              !errors.supplier_currency
                                            }
                                            isInvalid={
                                              errors.supplier_currency &&
                                              touched.supplier_currency
                                            }
                                            name="supplier_currency"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            defaultValue={values.supplier_currency}
                                          >
                                            <option value="">Choose ...</option>

                                            {CurrencyCodes.map((currency, i) => (
                                              <option key={i} value={currency.code}>
                                                {currency.code} -{" "}
                                                {currency.currency}
                                              </option>
                                            ))}
                                          </Form.Control>

                                          {errors.supplier_currency &&
                                            touched.supplier_currency && (
                                              <Form.Control.Feedback type="invalid">
                                                {errors.supplier_currency}
                                              </Form.Control.Feedback>
                                            )}
                                        </Form.Group>
                                      </Col>
                                      {varying_sizes === 0 && (
                                        <Col sm="6">
                                          <Form.Group
                                            controlId=""
                                            style={{ marginTop: "1em" }}
                                          >
                                            <Form.Label>Supplier Price</Form.Label>

                                            <Form.Control
                                              type="number"
                                              placeholder="Supplier Price"
                                              name="supplier_price"
                                              isValid={
                                                touched.supplier_price &&
                                                !errors.supplier_price
                                              }
                                              isInvalid={
                                                errors.supplier_price &&
                                                touched.supplier_price
                                              }
                                              value={values.supplier_price}
                                              onChange={(e) => this.handleSupplierSinglePriceChange(e, handleChange, values, varying_sizes, setFieldValue)}
                                            />

                                            {errors.supplier_price &&
                                              touched.supplier_price && (
                                                <Form.Control.Feedback type="invalid">
                                                  {errors.supplier_price}
                                                </Form.Control.Feedback>
                                              )}
                                          </Form.Group>
                                        </Col>
                                      )}
                                    </Row>
                                    <Row>
                                      {varying_sizes === 0 && (
                                        <Col sm="6">
                                          <Form.Group
                                            style={{ marginTop: "1em" }}
                                            controlId="price"
                                          >
                                            <Form.Label>Price</Form.Label>

                                            <Form.Control
                                              type="number"
                                              placeholder="Price"
                                              name="price"
                                              isValid={
                                                touched.price && !errors.price
                                              }
                                              isInvalid={
                                                errors.price && touched.price
                                              }
                                              value={values.price}
                                              onChange={handleChange}
                                            />

                                            {errors.price && touched.price && (
                                              <Form.Control.Feedback type="invalid">
                                                {errors.price}
                                              </Form.Control.Feedback>
                                            )}
                                          </Form.Group>
                                        </Col>
                                      )}

                                      {varying_sizes === 0 && (
                                        <Col sm="6">
                                          <Form.Group
                                            style={{ marginTop: "1em" }}
                                            controlId="price"
                                          >
                                            <Form.Label>Below MOQ Price</Form.Label>

                                            <Form.Control
                                              type="number"
                                              placeholder="Price"
                                              name="below_moq_price"
                                              isValid={
                                                touched.below_moq_price &&
                                                !errors.below_moq_price
                                              }
                                              isInvalid={
                                                errors.below_moq_price &&
                                                touched.below_moq_price
                                              }
                                              value={values.below_moq_price}
                                              onChange={handleChange}
                                            />

                                            {errors.below_moq_price &&
                                              touched.below_moq_price && (
                                                <Form.Control.Feedback type="invalid">
                                                  {errors.below_moq_price}
                                                </Form.Control.Feedback>
                                              )}
                                          </Form.Group>
                                        </Col>
                                      )}
                                    </Row>
                                    <Row>
                                      <Col sm="6">
                                        <Form.Group
                                          style={{ marginTop: "1em" }}
                                          controlId=""
                                        >
                                          <Form.Label>Target/Supplier MOQ</Form.Label>

                                          <Form.Control
                                            type="number"
                                            placeholder="Target/Supplier MOQ"
                                            name="quantity"
                                            isValid={
                                              touched.quantity && !errors.quantity
                                            }
                                            isInvalid={
                                              errors.quantity && touched.quantity
                                            }
                                            value={values.quantity}
                                            onChange={handleChange}
                                          />

                                          {errors.quantity && touched.quantity && (
                                            <Form.Control.Feedback type="invalid">
                                              {errors.quantity}
                                            </Form.Control.Feedback>
                                          )}
                                        </Form.Group>
                                      </Col>
                                      <Col sm="6">
                                        <Form.Group
                                          style={{ marginTop: "1em" }}
                                          controlId=""
                                        >
                                          <Form.Label>MOQ Per Person</Form.Label>

                                          <Form.Control
                                            type="number"
                                            placeholder="MOQ Per Person"
                                            name="min_quantity"
                                            isValid={
                                              touched.min_quantity &&
                                              !errors.min_quantity
                                            }
                                            isInvalid={
                                              errors.min_quantity &&
                                              touched.min_quantity
                                            }
                                            value={values.min_quantity}
                                            onChange={handleChange}
                                          />

                                          {errors.min_quantity &&
                                            touched.min_quantity && (
                                              <Form.Control.Feedback type="invalid">
                                                {errors.min_quantity}
                                              </Form.Control.Feedback>
                                            )}
                                        </Form.Group>
                                      </Col>
                                    </Row>
                                    {varying_sizes === 1 && (
                                      <Card style={{ marginTop: "1.5em" }}>
                                        <Card.Header as="h7">Pricing Per Attribute</Card.Header>
                                        <Card.Body>
                                          <Col sm="12">
                                            {moq_attributes.map((x, i) => (
                                              <Row
                                                key={i}
                                                style={{
                                                  borderBottom: "1px solid #eee",
                                                  paddingBottom: "0.75em",
                                                  marginBottom: "0.75em",
                                                }}
                                              >
                                                <Col sm="3">
                                                  <Form.Group>
                                                    <Form.Label style={{ fontSize: "0.85rem" }}>Select size</Form.Label>
                                                    <Form.Control
                                                      as="select"
                                                      name="size_id"
                                                      value={x.size_id}
                                                      onChange={(e) => this.handleInputChange(e, i)}
                                                      disabled={loading}
                                                    >
                                                      <option value="">Select size...</option>
                                                      {this.state.sizes !== null &&
                                                        this.state.sizes.map((size, idx) => (
                                                          <option key={idx} value={size.id}>
                                                            {size.label}
                                                          </option>
                                                        ))}
                                                    </Form.Control>
                                                  </Form.Group>
                                                </Col>

                                                <Col sm="3">
                                                  <Form.Group>
                                                    <Form.Label style={{ fontSize: "0.85rem" }}>Supplier Price</Form.Label>
                                                    <Form.Control
                                                      type="number"
                                                      placeholder="Supplier Price"
                                                      name="supplier_price"
                                                      value={x.supplier_price}
                                                      onChange={(e) => this.handleInputChange(e, i, values, setFieldValue)}
                                                      disabled={loading}
                                                    />
                                                  </Form.Group>
                                                </Col>

                                                <Col sm="3">
                                                  <Form.Group>
                                                    <Form.Label style={{ fontSize: "0.85rem" }}>MOQ Price</Form.Label>
                                                    <Form.Control
                                                      type="number"
                                                      placeholder="Price"
                                                      name="price"
                                                      value={x.price}
                                                      onChange={(e) => this.handleInputChange(e, i)}
                                                      disabled={loading}
                                                      min={0}
                                                    />
                                                  </Form.Group>
                                                </Col>

                                                <Col sm="3">
                                                  <Form.Group>
                                                    <Form.Label style={{ fontSize: "0.85rem" }}>Below MOQ Price</Form.Label>
                                                    <Form.Control
                                                      type="number"
                                                      placeholder="Below MOQ Price"
                                                      name="below_moq_price"
                                                      value={x.below_moq_price}
                                                      onChange={(e) => this.handleInputChange(e, i)}
                                                      disabled={loading}
                                                      min={0}
                                                    />
                                                  </Form.Group>
                                                </Col>

                                                <Col sm="3">
                                                  <Form.Group>
                                                    <Form.Label style={{ fontSize: "0.85rem" }}>Approx. Weight (in grams)</Form.Label>
                                                    <Form.Control
                                                      type="number"
                                                      placeholder="Approx. Weight (in grams)"
                                                      name="weight"
                                                      value={x.weight}
                                                      onChange={(e) => this.handleInputChange(e, i, values)}
                                                      disabled={loading}
                                                      min={0}
                                                    />
                                                  </Form.Group>
                                                </Col>

                                                <Col sm="3">
                                                  <Form.Group>
                                                    <Form.Label style={{ fontSize: "0.85rem" }}>Approx. Shipping Air</Form.Label>
                                                    <Form.Control
                                                      type="number"
                                                      placeholder="Approx. Shipping Fee Air"
                                                      name="shipping_fee_air"
                                                      value={x.shipping_fee_air}
                                                      onChange={(e) => this.handleInputChange(e, i)}
                                                      disabled={loading}
                                                    />
                                                  </Form.Group>
                                                </Col>
                                                <Col sm="3">
                                                  <Form.Group controlId="formVolume">
                                                    <Form.Label style={{ fontSize: "0.85rem" }}>Approx. Volume (L x W x H)</Form.Label>

                                                    <div className="d-flex gap-2">
                                                      <InputGroup className="flex-fill">
                                                        <Form.Control
                                                          type="number"
                                                          placeholder="L"
                                                          name="length"
                                                          value={x.length}
                                                          disabled={loading}
                                                          min={0}
                                                          onChange={(e) => this.handleInputChange(e, i, values)}
                                                        />
                                                        <InputGroup.Text 
                                                          className="rounded-start-0" 
                                                          style={{ padding: "0.25rem 0.5rem", fontSize: "0.85rem" }}
                                                        >
                                                          cm
                                                        </InputGroup.Text>
                                                      </InputGroup>

                                                      <InputGroup className="flex-fill">
                                                        <Form.Control
                                                          type="number"
                                                          placeholder="W"
                                                          name="width"
                                                          value={x.width}
                                                          disabled={loading}
                                                          min={0}
                                                          onChange={(e) => this.handleInputChange(e, i, values)}
                                                        />
                                                        <InputGroup.Text 
                                                          className="rounded-start-0" 
                                                          style={{ padding: "0.25rem 0.5rem", fontSize: "0.85rem" }}
                                                        >
                                                          cm
                                                        </InputGroup.Text>
                                                      </InputGroup>

                                                      <InputGroup className="flex-fill">
                                                        <Form.Control
                                                          type="number"
                                                          placeholder="H"
                                                          name="height"
                                                          value={x.height}
                                                          disabled={loading}
                                                          min={0}
                                                          onChange={(e) => this.handleInputChange(e, i, values)}
                                                        />
                                                        <InputGroup.Text 
                                                          className="rounded-start-0" 
                                                          style={{ padding: "0.25rem 0.5rem", fontSize: "0.85rem" }}
                                                        >
                                                          cm
                                                        </InputGroup.Text>
                                                      </InputGroup>
                                                    </div>
                                                  </Form.Group>
                                                </Col>

                                                <Col sm="3">
                                                  <Form.Group>
                                                    <Form.Label style={{ fontSize: "0.85rem" }}>Approx. Shipping Sea</Form.Label>
                                                    <Form.Control
                                                      type="number"
                                                      placeholder="Approx. Shipping Fee Sea"
                                                      name="shipping_fee_sea"
                                                      value={x.shipping_fee_sea}
                                                      onChange={(e) => this.handleInputChange(e, i)}
                                                      disabled={loading}
                                                    />
                                                  </Form.Group>
                                                </Col>

                                                <Col sm="3">
                                                  <Form.Group>
                                                    {/* Hidden label keeps alignment consistent */}
                                                    <Form.Label style={{ visibility: "hidden" }}>Actions</Form.Label>
                                                    <div>
                                                      {moq_attributes.length - 1 === i && (
                                                        <Button
                                                          variant="success"
                                                          style={{ marginRight: "0.5em" }}
                                                          onClick={this.handleAddClick}
                                                        >
                                                          <FiPlus />
                                                        </Button>
                                                      )}
                                                      {moq_attributes.length !== 1 && (
                                                        <Button
                                                          variant="danger"
                                                          onClick={() => this.handleRemoveClick(i)}
                                                        >
                                                          <FiTrash2 />
                                                        </Button>
                                                      )}
                                                    </div>
                                                  </Form.Group>
                                                </Col>
                                              </Row>
                                            ))}
                                          </Col>
                                        </Card.Body>
                                      </Card>
                                    )}
                                  </Card.Body>
                                </Card>
                                {varying_sizes !== 1 && (
                                  <Card style={{ marginTop: "1.5em" }}>
                                    <Card.Header as="h6">Shipping Details</Card.Header>
                                    <Card.Body>
                                      <Row>
                                        <Col sm="6">
                                          <Form.Group
                                            style={{ marginTop: "1em" }}
                                            controlId=""
                                          >
                                            <Form.Label>Approx. Weight (in grams)</Form.Label>
    
                                            <Form.Control
                                              type="number"
                                              placeholder="Approx. Weight (in grams)"
                                              name="weight"
                                              isValid={touched.weight && !errors.weight}
                                              isInvalid={
                                                errors.weight && touched.weight
                                              }
                                              value={values.weight}
                                              onChange={(e) => this.handleSingleAirShippingChange(e, handleChange, varying_sizes, setFieldValue)}
                                            />
    
                                            {errors.weight && touched.weight && (
                                              <Form.Control.Feedback type="invalid">
                                                {errors.weight}
                                              </Form.Control.Feedback>
                                            )}
                                          </Form.Group>
                                        </Col>
                                        <Col sm="6">
                                          <Form.Group
                                            style={{ marginTop: "1em" }}
                                            controlId="formBasicEmail"
                                          >
                                            <Form.Label>Approx. Shipping Fee Air</Form.Label>
      
                                            <Form.Control
                                              type="number"
                                              placeholder="Approx. Shipping Fee Air"
                                              name="shipping_fee_air"
                                              isValid={
                                                touched.shipping_fee_air &&
                                                !errors.shipping_fee_air
                                              }
                                              isInvalid={
                                                errors.shipping_fee_air &&
                                                touched.shipping_fee_air
                                              }
                                              value={values.shipping_fee_air}
                                              onChange={handleChange}
                                            />
      
                                            {errors.shipping_fee_air &&
                                              touched.shipping_fee_air && (
                                                <Form.Control.Feedback type="invalid">
                                                  {errors.shipping_fee_air}
                                                </Form.Control.Feedback>
                                              )}
                                          </Form.Group>
                                        </Col>
                                      </Row>
                                      <Row>
                                        <Col sm="6">
                                          <Form.Group controlId="formVolume">
                                            <Form.Label style={{ marginTop: "1em" }}>Approx. Volume (L x W x H)</Form.Label>

                                            <div className="d-flex gap-2">
                                              <InputGroup className="flex-fill">
                                                <Form.Control
                                                  type="number"
                                                  placeholder="L"
                                                  name="length"
                                                  isValid={touched.length && !errors.length}
                                                  isInvalid={
                                                    errors.length && touched.length
                                                  }
                                                  value={values.length}
                                                  onChange={(e) => this.handleSingleSeaShippingChange(e, handleChange, varying_sizes, setFieldValue, values)}
                                                />
                                                <InputGroup.Text 
                                                  className="rounded-start-0" 
                                                  style={{ padding: "0.25rem 0.5rem", fontSize: "0.85rem" }}
                                                >
                                                  cm
                                                </InputGroup.Text>
                                                {errors.length && touched.length && (
                                                  <Form.Control.Feedback type="invalid">
                                                    {errors.length}
                                                  </Form.Control.Feedback>
                                                )}
                                              </InputGroup>

                                              <InputGroup className="flex-fill">
                                                <Form.Control
                                                  type="number"
                                                  placeholder="W"
                                                  name="width"
                                                  isValid={touched.width && !errors.width}
                                                  isInvalid={
                                                    errors.width && touched.width
                                                  }
                                                  value={values.width}
                                                  onChange={(e) => this.handleSingleSeaShippingChange(e, handleChange, varying_sizes, setFieldValue, values)}
                                                />
                                                <InputGroup.Text 
                                                  className="rounded-start-0" 
                                                  style={{ padding: "0.25rem 0.5rem", fontSize: "0.85rem" }}
                                                >
                                                  cm
                                                </InputGroup.Text>
                                                {errors.width && touched.width && (
                                                  <Form.Control.Feedback type="invalid">
                                                    {errors.width}
                                                  </Form.Control.Feedback>
                                                )}
                                              </InputGroup>

                                              <InputGroup className="flex-fill">
                                                <Form.Control
                                                  type="number"
                                                  placeholder="H"
                                                  name="height"
                                                  isValid={touched.height && !errors.height}
                                                  isInvalid={
                                                    errors.height && touched.height
                                                  }
                                                  value={values.height}
                                                  onChange={(e) => this.handleSingleSeaShippingChange(e, handleChange, varying_sizes, setFieldValue, values)}
                                                />
                                                <InputGroup.Text 
                                                  className="rounded-start-0" 
                                                  style={{ padding: "0.25rem 0.5rem", fontSize: "0.85rem" }}
                                                >
                                                  cm
                                                </InputGroup.Text>
                                                {errors.height && touched.height && (
                                                  <Form.Control.Feedback type="invalid">
                                                    {errors.height}
                                                  </Form.Control.Feedback>
                                                )}
                                              </InputGroup>
                                            </div>
                                          </Form.Group>
                                        </Col>
                                        <Col sm="6">
                                          <Form.Group
                                            style={{ marginTop: "1em" }}
                                            controlId="formBasicEmail"
                                          >
                                            <Form.Label>Approx. Shipping Fee Sea</Form.Label>
      
                                            <Form.Control
                                              type="number"
                                              placeholder="Approx. Shipping Fee Sea"
                                              name="shipping_fee_sea"
                                              isValid={
                                                touched.shipping_fee_sea &&
                                                !errors.shipping_fee_sea
                                              }
                                              isInvalid={
                                                errors.shipping_fee_sea &&
                                                touched.shipping_fee_sea
                                              }
                                              value={values.shipping_fee_sea}
                                              onChange={handleChange}
                                            />
      
                                            {errors.shipping_fee_sea &&
                                              touched.shipping_fee_sea && (
                                                <Form.Control.Feedback type="invalid">
                                                  {errors.shipping_fee_sea}
                                                </Form.Control.Feedback>
                                              )}
                                          </Form.Group>
                                        </Col>
                                      </Row>
                                    </Card.Body>
                                  </Card>
                                )}
                                <Row>
                                  <Col sm="6">
                                    <Form.Group
                                      style={{ marginTop: "1em" }}
                                      controlId=""
                                    >
                                      <Form.Label>Start Date</Form.Label>

                                      <Form.Control
                                        type="date"
                                        placeholder="Start Date"
                                        name="start_date"
                                        isValid={
                                          touched.start_date &&
                                          !errors.start_date
                                        }
                                        isInvalid={
                                          errors.start_date &&
                                          touched.start_date
                                        }
                                        value={values.start_date}
                                        onChange={handleChange}
                                      />

                                      {errors.start_date &&
                                        touched.start_date && (
                                          <Form.Control.Feedback type="invalid">
                                            {errors.start_date}
                                          </Form.Control.Feedback>
                                        )}
                                    </Form.Group>
                                  </Col>
                                  <Col sm="6">
                                    <Form.Group
                                      style={{ marginTop: "1em" }}
                                      controlId=""
                                    >
                                      <Form.Label>End Date</Form.Label>

                                      <Form.Control
                                        type="date"
                                        placeholder="End Date"
                                        name="end_date"
                                        isValid={
                                          touched.end_date && !errors.end_date
                                        }
                                        isInvalid={
                                          errors.end_date && touched.end_date
                                        }
                                        value={values.end_date}
                                        onChange={handleChange}
                                      />

                                      {errors.end_date && touched.end_date && (
                                        <Form.Control.Feedback type="invalid">
                                          {errors.end_date}
                                        </Form.Control.Feedback>
                                      )}
                                    </Form.Group>
                                  </Col>
                                </Row>
                                <Button
                                  variant="primary"
                                  type="submit"
                                  disabled={loading}
                                  style={{ marginTop: "12px" }}
                                >
                                  Create MOQ
                                </Button>
                              </Form>
                            )}
                          </Formik>
                        </Card.Body>
                      </Card>
                    </Col>
                  }
                </Row>
              )}
            </Col>
          </Row>
        </Container>
      </Layout>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    moqs: state.moqs,

    products: state.products,
  };
};

export default connect(mapStateToProps, { addMoq, getAllProducts, fetchPricing, fetchShippingFees })(
  withRouter(Create)
);
